import { Button, Card, CardContent, Grid } from '@mui/material'
import { useNavigate } from 'react-router-dom' 

import './Others.css'

const Others = () => {

    const navigate = useNavigate()

    return (
        <Grid item px={0.3}>
            <h3 className="others-page-title">دسترسی سریع</h3>
            <div className="safe-area">
                <Card sx={{ width: '100%',mb: 5 }} className="business-item">
                    <CardContent style={{ paddingBottom: 16 }}>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-users"></i>} onClick={() => navigate('about')}>درباره ما</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-eye"></i>} onClick={() => navigate('vision')}>چشم انداز سازمان</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-building"></i>} onClick={() => navigate('strategy')}>استراتژی سازمان</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-check"></i>} onClick={() => navigate('mission')}>ماموریت سازمان</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-list"></i>} onClick={() => navigate('rules')}>قوانین و مقررات</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-headset"></i>} onClick={() => navigate('support')}>اطلاعات پشتیبانی</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-question"></i>} onClick={() => navigate('faq')}>سوالات متداول</Button>
                        <Button fullWidth sx={{ mb: 2,py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-mobile"></i>} onClick={() => navigate('version-info')}>جزئیات نسخه ها</Button>
                        <Button fullWidth sx={{ py: 1.2 }} color="inherit" variant="outlined" startIcon={<i className="fal fa-phone"></i>} onClick={() => navigate('contact-us')}>تماس با ما</Button>
                    </CardContent>
                </Card>
            </div>
        </Grid>
    )
}

export default Others